import * as React from 'react';
import { connect } from 'react-redux';
import { IRole } from '@wiot/shared-domain/models/role/role';
import { IColumnObject } from '@wiot/shared-domain/models/device/device';
import LoadingIcon from '../../../components/shared/LoadingIcon';
import TableDataHeader from '../../../components/Table/TableDataHeader';
import NoResultsInfo from '../../../components/Table/NoResultsInfo';
import RenderOnCondition from '../../../components/RenderOnCondition';
import { AppState } from '../../../state/reducers/rootReducer';
import TableDataRow from './TableDataRow';

export interface TableDataProps {
  roles: IRole[];
  markOneRoleAsSelected: (id: string) => void;
  markAllRolesAsSelected: (event: React.FormEvent<HTMLInputElement>) => void;
  isLoading: boolean;
  refreshData: (column?: IColumnObject) => void;
  removeUnit: (id: string) => Promise<void>;
  isSelectAllChecked: boolean;
}

export interface TableDataState {
  columns: IColumnObject[];
}

const TABLE_HEADERS = [
  'role-name',
  'super-admin',
  'device-type',
  'page-access',
  'active-accounts',
  'actions',
];

class TableData extends React.Component<TableDataProps, TableDataState> {
  constructor(props: TableDataProps) {
    super(props);
    this.state = {
      columns: [],
    };
  }

  componentDidMount = async () => {
    this.props.refreshData();
    this.initState();
  };

  initState = () => {
    const columnState = TABLE_HEADERS.map((headerName: string) => ({
      name: headerName,
      visible: true,
      sortable: true,
    }));

    this.setState({ columns: columnState });
  };

  render() {
    if (this.props.isLoading) {
      return <LoadingIcon />;
    }

    const showResults = (this.props.roles && this.props.roles.length);

    return (
      <div className="device-manager__table__table__container">
        <table className="device-manager__table__table">
          <TableDataHeader
            withCheckbox
            tableHeaders={this.state.columns}
            markAllRowsAsSelected={this.props.markAllRolesAsSelected}
            isSelectAllChecked={this.props.isSelectAllChecked}
          />
          <tbody>
            <RenderOnCondition condition={showResults}>
              {
                this.props.roles.map((role: IRole) => (
                  <TableDataRow
                    role={role}
                    key={role.id}
                    selectOne={this.props.markOneRoleAsSelected}
                    removeUnit={this.props.removeUnit}
                    refreshRoles={this.props.refreshData}
                  />
                ))}
            </RenderOnCondition>
          </tbody>
        </table>
        <RenderOnCondition condition={!showResults}>
          <NoResultsInfo />
        </RenderOnCondition>
      </div>
    );
  }
}

const mapStateToProps = (state: AppState) => ({
  roles: state.roles,
  isLoading: state.isLoading,
});

export default connect(mapStateToProps)(TableData);
